import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      companyName: "SPID Consultants inc",
      companyDescription: "SPID Consultants is a consulting and IT services company created in 2009 has over 20 years of IT expertise in various business sectors.",
      home: "Home",
      contact: "Contact us",
      solutions: "Solutions",
      architectureTitle: "IT Architecture",
      architectureDesc: "At your service for 20 years, we offer system architecture services for businesses of all sizes and for a wide range of technologies and environments.",
      implementationTitle: "IT Implementations",
      implementationDesc: "Take advantage of our expertise for your infrastructure and software implementations. We support you in your Agile, DevOps and Cloud projects.",
      solutionsTitle: "Our Solutions",
      solutionsDesc: "Affordable and innovative solutions to boost your productivity and optimize your IT infrastructure.",
      learnMore: "Learn more",
      contactUs: "Contact us",
      about: "About",
      aboutUs: {
        title: "About us",
        expertiseTitle: "Our expertise at the service of your company",
        expertiseText1: "Our goal is to improve your company's productivity by assisting you in your IT integration or migration projects. We will build together the implementation of new services and technologies.",
        expertiseText2: "We put our expertise at the service of your company for the success of your IT infrastructure projects in order to master technological changes.",
        teamTitle: "Our team"
      },
      contactPage: {
        title: "Contact us",
        description: "Contact us for any questions regarding our company or services. We will do our best to get back to you as soon as possible.",
        address: "Longueuil, Canada",
        phone: "438-488-5480",
        email: "infoweb@spidconsultants.com"
      },
      footer: {
        copyright: "Copyright 2023 SPID Consultants inc. All rights reserved."
      }
    }
  },
  fr: {
    translation: {
      companyName: "SPID Consultants inc",
      companyDescription: "SPID Consultants est une société de consultation et de services Informatiques créer en 2009 possédant une expertise informatique de plus de 20 ans dans divers secteurs d'activités.",
      home: "Accueil",
      contact: "Contactez-nous",
      solutions: "Solutions",
      architectureTitle: "Architecture TI",
      architectureDesc: "À votre service depuis 20 ans, nous proposons des services d'architecture système aux entreprises de toutes tailles et pour une large gamme de technologies et d'environnements.",
      implementationTitle: "Implantations informatique",
      implementationDesc: "Profitez de notre expertise pour vos implantations d'infrastructure et logiciel. Nous vous accompagnons dans vos projets Agile, DevOps et Cloud.",
      solutionsTitle: "Nos Solutions",
      solutionsDesc: "Solutions abordables et innovantes pour booster votre productivité et optimiser votre infrastructure TI.",
      learnMore: "En savoir plus",
      contactUs: "Contactez-nous",
      about: "À propos",
      aboutUs: {
        title: "À propos de nous",
        expertiseTitle: "Notre expertise au service de votre entreprise",
        expertiseText1: "Notre objectif est d'améliorer la productivité de votre entreprise en vous assistant dans vos projets d'intégration ou de migration TI. Nous construirons ensemble la mise en place de nouveaux services et technologies.",
        expertiseText2: "Nous mettons notre expertise au service de votre entreprise pour la réussite de vos projets d'infrastructure TI afin de maîtriser les changements technologiques.",
        teamTitle: "Notre équipe"
      },
      contactPage: {
        title: "Contactez-nous",
        description: "Contactez-nous pour toutes questions relatives à notre société ou nos services. Nous ferons notre possible pour revenir vers vous au plus vite.",
        address: "Longueuil, Canada",
        phone: "438-488-5480",
        email: "infoweb@spidconsultants.com"
      },
      footer: {
        copyright: "Copyright 2023 SPID Consultants inc. Tous droits réservés."
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
